import type { Feature } from '../model/plans';


/** Строка выделяется, если она главная, либо это строка про команду и фича команд включена. */
export const isFeatureHighlighted = (feature: Feature, teamEnabled = false): boolean => (
    feature.isMajor || Boolean(feature.isTeam && teamEnabled)
);
